import { _ } from "libs";

import React, { FunctionComponent, useContext } from "react";
import SubPageLayout from "./subPageLayout";
import CardForm from "../../settings/cardForm";
import ReservationPageContext from "./reservationPageContext";

const AddCard: FunctionComponent<{}> = () => {
	const pageContext = useContext(ReservationPageContext);

	const { getPaymentCards, setPage, selectCard } = pageContext;

	return (
		<SubPageLayout title={_("bookingWizard.addCard.heading")} backPage={"payment"}>
			<div className="wizardBody">
				<CardForm
					onSubmit={async paymentMethod => {
						let cardId: string;
						if (typeof paymentMethod === "string") {
							cardId = paymentMethod;
						} else {
							cardId = paymentMethod.id;
						}
						await getPaymentCards();
						selectCard(cardId);
						setPage("payment");
					}}
				/>
			</div>
		</SubPageLayout>
	);
};

export default AddCard;
